import {AbsoluteCenter} from '@chakra-ui/react';
import {AdvancedMarker, useMap, useMapsLibrary} from '@vis.gl/react-google-maps';
import _ from 'lodash';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {clustersRequest} from '../../../reducers/pinsReducer';
import {sendAudioClick, sendNavTo, sendPanoLoad, sendPanoUnload, sendPlacesSearch} from '../../../vuplex';
import InAppPinsAndClusters from './InAppPinsAndClusters';
import PanoClusterIcon from './PanoClusterIcon';
import PinIcon from './PinIcon';

const MinimapPinsAndClusters = ({onClickCluster, showInAppPins}) => {
  const dispatch = useDispatch();

  const clusters = useSelector(s => s.pins.clusters.response) || [];
  const worldId = useSelector(s => s.inApp.world._id) || {};

  //TODO maybe hide a pin if pano is loaded. PanoMarker is sometimes in a different location than the pin though so maybe we leave it.
  // const panoIdLoaded = useSelector(s => s.inApp.panoId);
  // const panoLocationLoaded = useSelector(s => s.inApp.panoLocation);

  const map = useMap();
  const maps = useMapsLibrary('maps');
  const streetView = useMapsLibrary('streetView');
  const [hoveringId, setHoveringId] = useState();

  const pinSaveIsLoading = useSelector(s => s.pins.pinSaveRequest.isLoading);

  useEffect(() => {
    if (!map || !maps) return;

    const refresh = _.debounce(async () => {
      const bounds = map.getBounds();
      if (!bounds) {
        console.warn('no bounds');
        return;
      }
      const northEast = bounds.getNorthEast();
      const southWest = bounds.getSouthWest();

      await dispatch(clustersRequest({
        bounds: {
          topRight: {Latitude: northEast.lat(), Longitude: northEast.lng()},
          bottomLeft: {Latitude: southWest.lat(), Longitude: southWest.lng()},
        },
        worldId,
        zoom: map.getZoom() - 1,
      }));
      setHoveringId(null);
    }, 1000);

    const dragEndListenerId = map.addListener('dragend', refresh);
    const zoomChangedListenerId = map.addListener('zoom_changed', refresh);

    if (!pinSaveIsLoading) refresh();

    return () => {
      window.google.maps.event.removeListener(dragEndListenerId);
      window.google.maps.event.removeListener(zoomChangedListenerId);
    };
  }, [map, maps, pinSaveIsLoading, worldId]);

  // only show the first instance of a pinned pano
  const sortedUniqueClusters = _(clusters)
    .orderBy('id')
    .uniqWith((a, b) => a.streetViewId && a.streetViewId === b.streetViewId)
    .value();


  return (<>
    {sortedUniqueClusters.map((clusterData, idx) => {
      const {
        location: {Latitude: lat, Longitude: lng},
        isInPrivateFolder,
        isInSharedFolder,
        numPins,
        streetViewId,
        streetViewIdIsApi2025,
        zoomToExpand,
      } = clusterData;

      const isCluster = !!numPins;

      return (
        <AdvancedMarker
          key={idx}
          onClick={(e) => {
            e.stop();
          }}
          position={{lat, lng}}
        >
          <AbsoluteCenter pointerEvents="none">
            {isCluster
              ? (
                <PanoClusterIcon
                  count={numPins}
                  onClick={(e) => {
                    sendAudioClick(e);
                    onClickCluster();
                    map.setZoom(zoomToExpand + 1);
                    map.setCenter({lat, lng});
                  }}
                  size="5em"
                />)
              : ((hoveringId === null) || (idx === hoveringId)) && ( // TODO: location icon
                <PinIcon
                  isPrivate={isInPrivateFolder}
                  isShared={isInSharedFolder}
                  onClick={(e) => {

                    if (!window.vuplex) { // TODO: proper module for Goood
                      const pano = new streetView.StreetViewPanorama(
                        document.getElementById("pano"),
                        {
                          pano: streetViewId,
                        }
                      );
                      console.log(pano);
                      return;
                    }

                    sendAudioClick(e);
                    if (streetViewId) {
                      sendPanoLoad({
                        lat,
                        lon: lng,
                        panoId: streetViewId,
                        panoIdIsApi2025: streetViewIdIsApi2025,
                      });
                      setHoveringId(null);
                    } else {
                      sendPanoUnload();
                      sendPlacesSearch({ids: [clusterData._id]});
                      setHoveringId(null);
                      sendNavTo({
                        lat,
                        lon: lng, // TODO: maybe zoom and alt
                      })
                    }
                  }}
                  onPointerEnter={() => {
                    setHoveringId(idx);
                  }}
                  onPointerLeave={() => {
                    setHoveringId(null);
                  }}
                  pin={clusterData}
                  size="5em"
                  streetViewId={streetViewId}
                />
              )}
          </AbsoluteCenter>

        </AdvancedMarker>
      );
    })}

    {showInAppPins && <InAppPinsAndClusters />}
  </>);
};

export default MinimapPinsAndClusters;
